import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthorService } from '@services/author/author.service';
import { NavigationExtras, Router } from '@angular/router';
import { QueueService } from '@services/queue/queue.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthorAPIResponse } from 'src/app/shared/interface/author.interface';
import { TrackingService } from '@services/track/tracking.service';
import { AnalysisStatus } from 'src/app/shared/interface/analysis';
import { Subscription } from 'rxjs';
import * as ld from 'launchdarkly-js-client-sdk';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { ActionEvaluateEsocial } from 'src/app/shared/enum/action-evaluate-esocial';

@Component({
  selector: 'analysis-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  @Input() active: boolean;
  @Output() showMenu: EventEmitter<boolean> = new EventEmitter();

  showAudit: boolean;
  showReport: boolean;
  featureFlagEsocial = {
    approvedEsocialFields: false,
    overrideEsocialName: false,
    newEsocialFlow: false,
    esocialWithoutPis: false
  };

    // Arrow function to return a random item from an array
    random_item = items => items[Math.floor(Math.random() * items.length)];

  constructor(
    private authorService: AuthorService,
    private queueService: QueueService,
    private router: Router,
    private permService: NgxPermissionsService,
    private trackingService: TrackingService,
    private launchdarklyService: LaunchdarklyService) {
    }

  ngOnInit(): void {
    this.getInfoAuthor();
  }

  getInfoAuthor() {
    this.authorService.getAuthorInfo().subscribe(async (author: AuthorAPIResponse) => {
      const payload = {
        user_id: author?.id,
        name: author?.name,
        email: author?.email,
      }
      localStorage.setItem('analyst_email', author?.email);
      localStorage.setItem('id', author?.id);
      await this.evaluateFlags();
      this.trackingService.identify(payload);
      this.permService.loadPermissions(author.scopes);
    })
  }

  toggleMenu(): void {
    this.showMenu.emit(false);
  }

  logout() {
    this.authorService.logout();
    this.authorService.redirectLogout();
  }
  
  private getStatusFirstAnalysis(queue: Array<string>): void {
    if (queue?.length) {
      const itemAnalysis = queue.slice(0, 1).toString();
      this.queueService
        .getAnalysisStatus(itemAnalysis)
        .subscribe((response: AnalysisStatus) => {
          if (sessionStorage.getItem('state')) {
            sessionStorage.removeItem('state');
          }
          return this.redirectAnalysis(response)
        });
    }
  }

  private redirectAnalysis(status: AnalysisStatus): void {
    if (status?.ready) {
      const id: NavigationExtras = {
        queryParams: { id: status?.id },
      };
      this.router.navigate(['/analysis'], id);
    }
  }

  private async checkLaunchDarklyFlag(flagKey: string = '', actionName?: ActionEvaluateEsocial): Promise<boolean> {
    const ctx = {
      kind: 'user',
      key: localStorage.getItem('id'),
      custom: {
        'actionName': actionName,
      },
    } as ld.LDContext;
    await this.launchdarklyService?.overrideContext({context: ctx});
    return this.launchdarklyService?.evaluateBoolean({flagKey});
  }

  async evaluateFlags() {
    await this.checkLaunchDarklyFlag("people-analysis-esocial-service", ActionEvaluateEsocial.NewEsocialFlow).then((flag) => {
      this.featureFlagEsocial[ActionEvaluateEsocial.NewEsocialFlow] = flag;
    });
    await this.checkLaunchDarklyFlag("people-analysis-esocial-service", ActionEvaluateEsocial.ApprovedEsocialFields).then((flag) => {
      this.featureFlagEsocial[ActionEvaluateEsocial.ApprovedEsocialFields] = flag;
    });
    await this.checkLaunchDarklyFlag("people-analysis-esocial-service", ActionEvaluateEsocial.OverrideEsocialName).then((flag) => {
      this.featureFlagEsocial[ActionEvaluateEsocial.OverrideEsocialName] = flag;
    });
    await this.checkLaunchDarklyFlag("people-analysis-esocial-consultation-default-pis").then((flag) => {
      this.featureFlagEsocial[ActionEvaluateEsocial.EsocialWithoutPis] = flag;
    });
    localStorage.setItem('featureFlagEsocial', JSON.stringify(this.featureFlagEsocial));
  }
}
